import { PASSWORD_POLICY_MESSAGE } from "../authFieldPolicy";

export const RESET_PASSWORD_UI = {
  title: "Set new password",
  successTitle: "Password updated",
  missingSessionTitle: "Reset password",
  submitLabel: "Update password",
  submittingLabel: "Updating…",
  successMessage:
    "You can now sign in with your new password. Redirecting…",
  missingSessionMessage:
    'Missing session. Please use "Reset password" from the app again, then come back here with the link.',
  backToAppLabel: "Back to app",
  sessionMissingOnSubmit:
    "Session missing. Please request a new reset link from the app.",
  submitErrorMessage:
    "Invalid or expired code. Please request a new reset link and try again.",
  codeRequiredError: "Please enter the code from your email.",
  resetFields: [
    {
      name: "code",
      label: "Code from email",
      type: "text",
      required: true,
      placeholder: "Enter the code sent to your email"
    },
    {
      name: "password",
      label: "New password",
      type: "password",
      required: true,
      placeholder: "e.g. MyPass1!",
      info: PASSWORD_POLICY_MESSAGE
    },
    {
      name: "confirmPassword",
      label: "Confirm new password",
      type: "password",
      required: true,
      placeholder: "Confirm new password",
      info: "Re-enter the same password.",
      showPasswordToggle: true,
    },
  ],
};
